import React from 'react';
import Header from '../Header/Header';
import Volenters from '../Volenters/Volenters';

const RegistedVolenter = () => {
    return (
        <div>
              <Header></Header>
            <Volenters></Volenters> 
        </div>
    );
};

export default RegistedVolenter;